import React, { useEffect } from 'react';
import { Alert } from 'antd';

import QuickTurnPartStore from '../../../stores/QuickTurnPartStore';

const QuickTurnProgramCapacityAlert: React.FC = () => {
    useEffect(() => {
        QuickTurnPartStore.getCompanyParams('PortalEnabledParam');
    }, []);

    return (
        <>
            {!QuickTurnPartStore.isPortalEnabled && (
                <Alert
                    type="warning"
                    showIcon={true}
                    message="QuickTurn Program Capacity"
                    description={
                        <div className="flex flex-col">
                            <div>
                                <span>
                                    The QuickTurn Program is currently at capacity and not accepting new orders at this
                                    time.
                                </span>
                            </div>
                        </div>
                    }
                    className="mt-3 mb-3 align-center"
                />
            )}
        </>
    );
};

export default QuickTurnProgramCapacityAlert;
